import React from 'react';
import { Controller, useForm } from 'react-hook-form';

import { ListProfessionalPageStyled } from './ListProfessionalPageStyled';
import PaginationComponent from '../../component/pagination/PaginationComponent';
import { Badge, Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import ContainerSideBarComponent from '../../component/container/ContainerSidebarComponent';

import { FaRegEye } from 'react-icons/fa6';
import { FaPlus, FaSearch, FaTrashAlt } from 'react-icons/fa';

import { InputsSearchProfessional, PropsListProfessional } from './ListProfessionalPageType';
import { maskUtils } from '../../../main/helper/maskHelper';
import AlertComponent from '../../component/alert/AlertComponent';
import { ProfilesConstant } from '../../../main/constant/ProfilesConstant';

/**
 * ListProfessionalPage
 * @param add
 * @param list
 * @param remove
 * @param edit
 * @param search
 * @param pagination
 * @param toggle
 * @constructor
 */
const ListProfessionalPage: React.FC<PropsListProfessional> = ({ add, list, remove, edit, search, pagination, toggle }: PropsListProfessional) => {
  /**
   * Perfil de acesso
   */
  const PROFILE_ADMIN = ProfilesConstant.admin;
  const PROFILE_DENTISTA = ProfilesConstant.dentist;
  const PROFILE_RECEPCIONISTA = ProfilesConstant.receptionist;

  /**
   * useForm
   */
  const { register, getValues, control, setValue } = useForm<InputsSearchProfessional>();

  return (
    <ContainerSideBarComponent>
      <AlertComponent />
      <ListProfessionalPageStyled>
        <Container fluid className="title-page">
          <h3>Profissionais</h3>
        </Container>

        <Container fluid>
          <Row className="row-field-filter align-items-end">
            <Col xs={12} sm={8} md={6} lg={6} className="mb-3 mb-md-0">
              <Form.Label>Pesquise um profissional pelo nome</Form.Label>
              <Form.Control type="text" placeholder="Pesquise um profissional pelo nome" {...register('nome')} />
            </Col>
            <Col xs={12} sm={4} md={3} lg={3} className="mb-3 mb-md-0">
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Controller
                  name="status"
                  control={control}
                  defaultValue="Ativos"
                  render={({ field }) => (
                    <Form.Select {...field}>
                      <option value="Ativos">Ativos</option>
                      <option value="Inativos">Inativos</option>
                    </Form.Select>
                  )}
                />
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={3} lg={3} className="filter-btn d-flex gap-2 mt-3 mt-md-0">
              <Button
                size="sm"
                variant="outline-primary"
                onClick={() =>
                  search({
                    nome: getValues('nome'),
                    status: getValues('status'),
                  })
                }>
                <FaSearch />
                <span>Pesquisar</span>
              </Button>
              <Button size="sm" onClick={add}>
                <FaPlus />
                <span>Novo</span>
              </Button>
            </Col>
          </Row>
        </Container>
        <Container fluid className="table-page">
          <div style={{ overflowX: 'auto', maxHeight: '600px' }}>
            <Table responsive striped bordered={false} hover style={{ whiteSpace: 'nowrap' }}>
              <thead>
                <tr>
                  <th>CRO</th>
                  <th>Nome</th>
                  <th>Celular</th>
                  <th>Email</th>
                  <th>Perfil</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {list.map((item: any) => (
                  <tr key={item.id} onClick={() => edit(item.id)}>
                    <td>{item.boardRegistration}</td>
                    <td>{item.name}</td>
                    <td>{maskUtils.celular(item.cellPhone)}</td>
                    <td>{item.email}</td>
                    <td>
                      {(() => {
                        switch (item.profileDescription) {
                          case PROFILE_ADMIN:
                            return 'Administrador';
                          case PROFILE_DENTISTA:
                            return 'Dentista';
                          case PROFILE_RECEPCIONISTA:
                            return 'Recepcionista';
                          default:
                            return item.profileDescription; // Retorna o valor original se não houver correspondência
                        }
                      })()}
                    </td>
                    <td>
                      <div className="table-btn">
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          label="Ativo"
                          checked={item.status === 'A'}
                          disabled={item.profileDescription === PROFILE_ADMIN}
                          onChange={async (e) => {
                            if (e.target.checked) {
                              setValue('status', 'Ativos');
                            } else {
                              setValue('status', 'Inativos');
                            }
                            await toggle(item.id);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <PaginationComponent
            totalPages={pagination?.totalPages}
            pageIndex={pagination?.pageIndex}
            onClickItem={pagination?.onClickItem}
            hasPreviousPage={pagination?.hasPreviousPage}
            hasNextPage={pagination?.hasNextPage}
          />
        </Container>
      </ListProfessionalPageStyled>
    </ContainerSideBarComponent>
  );
};

export default ListProfessionalPage;
